import { ConfigStateService, CoreModule, PermissionService, ShowPasswordDirective } from '@abp/ng.core';
import { ThemeSharedModule, DateAdapter, TimeAdapter } from '@abp/ng.theme.shared';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  NgbNavModule,
  NgbDatepickerModule,
  NgbTimepickerModule,
  NgbDateAdapter,
  NgbTimeAdapter,
} from '@ng-bootstrap/ng-bootstrap';
import { GalileuCredentialDetailViewService } from '../services/galileu-credential-detail.service';
import { GetGalileuCredentialsInput } from '@proxy/galileu-credentials';
import { GalileuCredentialViewService } from '../services/galileu-credential.service';

/** Permissão-pai do módulo: quem a tem gere a credencial do tenant (criar, trocar, limpar). */
const PERMISSAO_GERIR_CREDENCIAL = 'cargo_fleet.GalileuCredentials';

@Component({
  selector: 'app-galileu-credential-detail-modal',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbTimepickerModule,
    NgbNavModule,
    ShowPasswordDirective
  ],
  providers: [
    { provide: NgbDateAdapter, useClass: DateAdapter },
    { provide: NgbTimeAdapter, useClass: TimeAdapter },
  ],
  templateUrl: './galileu-credential-detail.component.html',
  styles: [],
})
export class GalileuCredentialDetailModalComponent implements OnInit {
  public readonly service = inject(GalileuCredentialDetailViewService);
  protected readonly serviceCredential = inject (GalileuCredentialViewService);
  private readonly permissionService = inject(PermissionService);
  protected id: string;

  showPassword = false

  /** Só quem tem a permissão de gestão troca ou limpa a credencial — o resto só enxerga o login. */
  podeGerir = false;

  protected filters: GetGalileuCredentialsInput = { maxResultCount: 1 };

  constructor(private config: ConfigStateService,  private cdRef: ChangeDetectorRef  ) { }

  ngOnInit(): void {
    this.podeGerir = this.permissionService.getGrantedPolicy(PERMISSAO_GERIR_CREDENCIAL);
    this.service.create()
    this.getData();
  }

  limparCredenciais()
  {
    this.serviceCredential.delete(this.service.selected);
    this.service.form.reset()
  }

  // A credencial é do TENANT (RN-010.6), não do usuário: não filtra por identityUserId, senão um
  // colega criado depois pela aba Usuários e Acessos abria a aba vazia mesmo com o tenant sincronizando.
  getData()
  {
    this.config.getOne$('currentUser').subscribe(currentUser => {
      if (this.podeGerir) {
        // Quem gere precisa do registro completo (id + concurrencyStamp) para trocar/limpar.
        this.service.proxyService.getList(this.filters).subscribe(result => {
          if (result.items && result.items.length > 0) {
            this.service.update(result.items[0]);
          }

          // Quem salva passa a constar como quem cadastrou.
          this.service.form.patchValue({
            identityUserId: currentUser.id,
          });

          this.cdRef.detectChanges();
        });
        return;
      }

      // Usuário comum: leitura liberada só do login, sem senha; formulário travado.
      this.service.proxyService.getDoTenant().subscribe(credencial => {
        if (credencial) {
          this.service.form.patchValue({ login: credencial.login });
        }
        this.service.form.disable();
        this.cdRef.detectChanges();
      });
    });
  }



}
